<template>
  <div class="xcard">
    <h3 class="text-center text-primary">Registro de Persona</h3>
    <p class="text-center">Complete el siguiente formulario con los datos de la persona para registralo en el sistema.</p>
    <a-reg-people></a-reg-people>
  </div>
</template>

<script>
import ARegPeople from '@/components/ARegPeople.vue';
export default {
  components: { ARegPeople },
};
</script>